import { Routes, Route, Navigate } from 'react-router-dom';
import { RELEASE_ROUTES, LATEST_RELEASE } from './routes';
import NotFoundPage from '../pages/NotFoundPage';
import VersionsPage from '../pages/VersionsPage';

function AppRouter() {
  return (
    <Routes>
      {/* Root redirect — always goes to the latest release */}
      <Route path="/" element={<Navigate to={`/${LATEST_RELEASE}`} replace />} />

      {/* Dedicated page listing every available release version */}
      <Route path="/versions" element={<VersionsPage />} />

      {/* Dynamically generated release routes from the registry */}
      {RELEASE_ROUTES.map(({ slug, component: PageComponent }) => (
        <Route key={slug} path={`/${slug}`} element={<PageComponent />} />
      ))}

      {/* Catch-all for unrecognised paths */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default AppRouter;
